import React from 'react'
import ZoneHeadList from '../../features/admin/ZoneHeadList'

const ZoneHeadListPage = () => {
  return <ZoneHeadList/>
}

export default ZoneHeadListPage